import script from "./AdBrandProductTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AdBrandProductTable.vue?vue&type=script&setup=true&lang=js"

import "./AdBrandProductTable.vue?vue&type=style&index=0&id=63537d39&lang=scss"

const __exports__ = script;

export default __exports__